$(document).ready(function () {

  $( ".card-information .price" ).each( function( i ) {
    if($(this).hasClass("price--on-sale")){}
    else{
      $(this).addClass("quoteSale").text("Get a Quote").css({"color": "green", "border":"1px solid green","padding":"12px","text-align":"center","border-radius":"4px"});
    }
  });
 //$("#testP").text($("#testP").parent().find("#piceReg .price-item.price-item--regular").text());
  //$(".customSizeLink").on('click', function(){
   // console.log('link click');
    //$(".getQuote").text("Rs. 120.00");
   // $(".custom-size-product-input").addClass('active');
 // });
  function callCalculation(widthVal, heightVal) {
    console.log("Width:", widthVal);
    console.log("Height:", heightVal);
    var panels = widthVal/22; //5
    
    panels = Math.round(panels);
    console.log('panels ', panels);
    
    var quntity = (parseInt(heightVal) + 12) * 0.0254 * panels; //12.5
    console.log('quntity ', quntity);
    
    var stitchingCost = panels * 250; //1250
    console.log('stitchingCost  ', stitchingCost);
    
    curtainMRPInitail = (quntity * 150) + stitchingCost; //3125
    console.log('curtainMRPInitail  ', curtainMRPInitail);
    
    $(".price-item.price-item--regular").text("Rs. "+ Math.round(curtainMRPInitail));
  }
  $("#custom_size_width").on('keyup', function() {
    if($("#custom_size_height").val()>0){
      //console.log('test width', $(this).val());
      callCalculation($(this).val(), $("#custom_size_height").val());
    }
  });
  $("#custom_size_height").on('keyup', function() {
    if($("#custom_size_width").val()>0){
      callCalculation($("#custom_size_width").val(),$(this).val());
    }
  });

  $("#ProductSubmitButton-template--14756885233713__main").on('click', function (e) {
    console.log('tst btn');
    e.preventDefault();
    var formId = document.getElementById('product-form-template--14756885233713__main'); 
    var formData = new FormData(formId); 
    $.ajax({ 
          url: '/cart/add', 
          method: 'POST', 
          data: formData, 
          dataType: 'json',
          processData: false,
          contentType: false,
          success: function (response) {                       
                   console.error("Success - Form sent"); 
          }, 
          error: function (xhr, status, error) {      
                 console.error("Form not sent", xhr); 
          } 
     });
  });
});